import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
          {contactData.title}
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          {contactData.subtitle}
        </p>
        <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-2xl mx-auto">
          {contactData.description}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
          <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-100">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-line text-lg"></i>
            </span>
            <div className="text-left">
              <div className="text-xs text-foreground-500">电子邮箱</div>
              <div className="text-sm font-semibold text-foreground-800">{contactData.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-100">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-wechat-line text-lg"></i>
            </span>
            <div className="text-left">
              <div className="text-xs text-foreground-500">微信公众号</div>
              <div className="text-sm font-semibold text-foreground-800">{contactData.wechat}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}